import { Getter, Setter, useSetAtom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router';
import { cloneDeep } from 'lodash-es';
import { primaryCaptableStateJ } from '../../../../services/state/CapTableDataStateJ';
import { currentScenarioStateJ, scenariosByIdMapStateJ } from '../../../../services/state/ScenariosStateJ';
import { selectedCompanyIdProfileAtom } from '../../state/UIStateJ';
import { getForesightStore } from '../../../../util/jotai-store';
import { ActiveScenarioIdParamName, DuplicateParam } from '../constants';
import {
  initialScenarioFormValues,
  prepareScenarioForDuplication,
} from '../SingleScenario/form/scenarioInitialValues';

export function useSetScenarioStateFromPath() {
  const [search] = useSearchParams();
  const [ready, setReady] = useState(false);
  const setCurrentScenario = useSetAtom(currentScenarioStateJ);

  const setInitialScenarioState = useAtomCallback(
    useCallback(
      async (get: Getter, set: Setter) => {
        const companyId = getForesightStore().get(selectedCompanyIdProfileAtom);
        const activeScenarioId = search.get(ActiveScenarioIdParamName);
        const shouldDuplicate = search.get(DuplicateParam);
        const primaryCaptable = await get(primaryCaptableStateJ(companyId));

        let current;
        if (!activeScenarioId) {
          current = initialScenarioFormValues({
            captableId: primaryCaptable?.id,
            companyId,
          });
        } else {
          const map = await get(scenariosByIdMapStateJ(companyId));
          current = map?.get(parseInt(activeScenarioId)) ?? null;

          if (current && shouldDuplicate) {
            current = prepareScenarioForDuplication(current);
          } else if (current) {
            current = cloneDeep(current);
          }
        }
        set(currentScenarioStateJ, current);
      },
      [search]
    )
  );

  useEffect(() => {
    setInitialScenarioState().then(() => setReady(true));

    return () => {
      setCurrentScenario(null);
      setReady(false);
    };
  }, [setCurrentScenario, setInitialScenarioState]);

  return ready;
}
